<template>
  <div class="container-fluid">
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
export default {
    name: 'Logout',
    data () {
        return {
        
        }
    },
    computed: {
            ...mapState([
                'baseUrl'
            ]),
        },
    methods:{
        logout(){
            axios({
            method:'post',
            url:'/logout',
            baseURL: this.baseUrl,
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
            if(res.data.status){
                this.$router.push('/login')
            }else{
                this.$router.push('/login')
            }
            localStorage.removeItem('loginCookie')
            localStorage.removeItem('roleId')
            localStorage.removeItem('cuid')
            localStorage.removeItem('rules')
            localStorage.removeItem('name')
            localStorage.removeItem('surname')
            this.$root.$refs.sip.disconnect()
            this.$root.$refs.Login.rememberMeMethod()
            })
        }
    },
    created(){
        this.logout()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
